@use "/src/styles/functions";

.triangle {
  position: relative;
  display: flex;
  transform: rotateX(180deg) translateY(44%);

  path {
    stroke: functions.getColor(var(--theme-stroke-soft-200));
    fill: functions.getColor(var(--theme-bg-white-0));
  }
  rect {
    fill: functions.getColor(var(--theme-bg-white-0));
  }
}

.label {
  z-index: 9999999;
  background-color: functions.getColor(var(--theme-bg-white-0));
  color: functions.getColor(var(--theme-text-strong-900));
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  transition: opacity 0.3s ease-in-out;
  cursor: default;
  user-select: none;
  max-width: functions.toRem(280);
  border: 1px solid functions.getColor(var(--theme-stroke-soft-200));

  &[data-size="large"] {
    border-radius: functions.radius(12);
    padding: functions.space(12);
    gap: functions.space(12);
  }
  &[data-size="x-small"] {
    border-radius: functions.radius(6);
    padding: functions.space(4) functions.space(10);
    gap: functions.space(4);
  }
  &[data-size="2x-small"] {
    border-radius: functions.radius(4);
    padding: functions.space(2) functions.space(6);
    gap: functions.space(2);
  }

  &__container {
    display: flex;
    align-items: flex-start;

    &[data-size="large"] {
      gap: functions.space(12);
    }
    &[data-size="x-small"] {
      gap: functions.space(4);
    }
    &[data-size="2x-small"] {
      gap: functions.space(2);
    }
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex: 0 0 auto;
  }

  &__content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: functions.space(4);
  }
}
